import { cdn } from 'consts';

export default (url) => {
	if (typeof url == 'string') {
		return cdn + url;
	}

	return cdn + '/not-found-image.png';
};
